import { render, staticRenderFns } from "./LKPublicationsFormdataDownloadTemplateLink.vue?vue&type=template&id=3f763131&"
import script from "./LKPublicationsFormdataDownloadTemplateLink.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataDownloadTemplateLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports